export function common() {


  jQuery(function () {

    // タブレット表示
    $(function(){
      var ua = navigator.userAgent;
      var viewport = document.querySelector("meta[name=viewport]");
      if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
          viewport.setAttribute("content", "width=device-width,initial-scale=1");
      } else {
          viewport.setAttribute("content", "width=1200");
      }
    });

    // スマホtel link
    if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
      jQuery(function() {
          $('.tel').each(function() {
              var str = $(this).html();
              if ($(this).children().is('img')) {
                  $(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/-/g, '')).append(str + '</a>'));
              } else {
                  $(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/-/g, '')).append(str + '</a>'));
              }
          });
      });
    }

    //正確なvhの取得
    /*-
    使い方: calc(var(--vh, 1vh) * 100);
    -*/
    function setHeight() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    setHeight();//初期化
    window.addEventListener('resize', setHeight);// 再計算



    //ブレイクポイント画像切り替え
    var $elem = $('.sp_img');
    var sp = '_sp.';
    var pc = '_pc.';
    var replaceWidth = 767; //ブレイクポイント指定

    function imageSwitch() {
      var windowWidth = parseInt($(window).width()); //ウィンドウサイズ取得
      $elem.each(function () {
          var $this = $(this);
          if (windowWidth >= replaceWidth) {
              $this.attr('src', $this.attr('src').replace(sp, pc));
          } else {
              $this.attr('src', $this.attr('src').replace(pc, sp));
          }
      });
    }
    imageSwitch();

    // リサイズの実行タイミング設定
    var delayStart;
    var delayTime = 200;
    $(window).on('resize', function () {
    clearTimeout(delayStart);
      delayStart = setTimeout(function () {
        imageSwitch();
      }, delayTime);
    });


    //ヘッダーの高さに連動
    function headerHeightSwitch() {
      var headerHeight = jQuery('.l-header').outerHeight(); //ウィンドウサイズ取得
      jQuery('.l-main_inner').css({'padding-top': headerHeight});
      jQuery('.anchor').css({'padding-top': headerHeight});
      jQuery('.anchor').css({'margin-top': -headerHeight});
    }
    headerHeightSwitch();
    jQuery(window).on('resize', function () {
      headerHeightSwitch();
    });


    //navi PC
    if (window.matchMedia('(min-width: 768px)').matches) {
      jQuery(function ($) {
          $('.menu-item-has-children').hover(function() {
              $(this).find('.sub-menu').stop().slideDown();
          }, function() {
              $(this).find('.sub-menu').stop().slideUp();
          });
      })
    }

    //navi sp
    if (window.matchMedia('(max-width: 1400px)').matches) {
      // 親メニュー処理
      $('.menu-item-has-children').click(function() {
        $(this).toggleClass('menu_open');
        // メニュー表示/非表示
        $(this).next('.sub-menu').slideToggle();
      });
      // 子メニュー処理
      $('.menu-item-has-children').click(function(e) {
          // メニュー表示/非表示
          $(this).children('.sub-menu').slideToggle();
          e.stopPropagation();
      });
    }

    //navi SP
    jQuery(function () {
      //bodyのスクロール位置の格納
      var state = false;
      var scrollpos;
      $('#toggle').click(function(){
          if($(this).hasClass('active')){
              $(this).removeClass('active');
              $('.l-header').removeClass('active');
              $('.l-header_navArea').fadeOut();
          }else{
              $(this).addClass('active');
              $('.l-header').addClass('active');
              $('.l-header_navArea').fadeIn().css({'display':'flex'});
          }
          if(state == false) {
            scrollpos = $(window).scrollTop()
            $('body').addClass('fixed').css({'top': -scrollpos})
            state = true;
          } else {
              $('body').removeClass('fixed').css({'top': 0}),
              window.scrollTo( 0 , scrollpos )
              state = false;
          }
      });
      $('.menu-item > a').click(function() {
          if($('.l-header').hasClass('active')){
              $('.l-header_navArea').fadeOut();
              $('.l-header').removeClass('active');
              $('#toggle').removeClass('active');
              if(state == false) {
                scrollpos = $(window).scrollTop()
                $('body').addClass('fixed').css({'top': -scrollpos})
                state = true;
              } else {
                  $('body').removeClass('fixed').css({'top': 0}),
                  window.scrollTo( 0 , scrollpos )
                  state = false;
              }
          }
      });
      $('.nav_close').click(function() {
          if($('.l-header').hasClass('active')){
              $('.l-header_navArea').fadeOut();
              $('.l-header').removeClass('active');
              $('#toggle').removeClass('active');
              if(state == false) {
                  scrollpos = $(window).scrollTop()
                  $('body').addClass('fixed').css({'top': -scrollpos})
                  state = true;
              } else {
                  $('body').removeClass('fixed').css({'top': 0}),
                  window.scrollTo( 0 , scrollpos )
                  state = false;
              }
          }
      });
    });

    //scroll_header
    var startPos = 0,winScrollTop = 0;
    var headerHight = $('.l-header_inner').outerHeight();
    jQuery(window).on('scroll',function(){
        winScrollTop = $(this).scrollTop();
        if (jQuery(this).scrollTop() > headerHight) {
          if (winScrollTop >= startPos) {
            jQuery('.scroll_header').addClass('hide').css({top: -headerHight});
          } else {
            jQuery('.scroll_header').removeClass('hide').css({top: 0});
          }
          startPos = winScrollTop;
      }
    });


    //js-scroll
    var wH = $(window).height();
    var EffectH = wH/6*1;
    jQuery(window).on('scroll load', function() {
      var scTop = $(this).scrollTop();
      var scBottom = scTop + $(this).height();
      var effectPos = scBottom - EffectH;
      jQuery('.js-scroll, .js-scroll-delay').each( function() {
        var thisPos = $(this).offset().top;
        if ( thisPos < effectPos ) {
          $.when(
            jQuery(this).addClass("show")
          ).done(function() {
            jQuery(this).delay(250).queue(function(){
                jQuery(this).addClass("done")
            })
          });
        }
      });
    });

    //c-splitText
    $(window).on('load', function () {
      //spanタグを追加する
      var element = $(".c-splitText");
      element.each(function () {
        var text = $(this).text();
        var textbox = "";
        text.split('').forEach(function (t, i) {
          if (t !== " ") {
            if (i < 10) {
              textbox += '<span class="char" style="animation-delay:.' + i + 's;">' + t + '</span>';
            } else {
              var n = i / 10;
              textbox += '<span class="char" style="animation-delay:' + n + 's;">' + t + '</span>';
            }
          } else {
            textbox += t;
          }
        });
        $(this).html(textbox);
      });
    });


    //
    const serviceSlide = document.querySelector('.serviceSlide');
    if(serviceSlide){
      jQuery(function () {
        jQuery(".serviceSlide").slick({
          autoplay: false,
          speed: 600,
          fade: true,
          dots: true,
          arrows: true,
          adaptiveHeight: true,
        });
      });
    }

    //ページトップ
    var pageTop = $('#pageTop');
    pageTop.hide();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 650) {
        pageTop.fadeIn();
      } else {
        pageTop.fadeOut();
      }
    });
    pageTop.click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 550);
      return false;
    });

    //スムーススクロール
    $('a[href^="#"]').click(function () {
      var speed = 550;
      var href = $(this).attr("href");
      //var headerHight = $('.l-header_inner').outerHeight();
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $("html, body").animate({ scrollTop: position }, speed, "swing");
      return false;
    });


    //追従ヘッダー
    function headerFloatSwitch() {
      const pos = $('#js-header').offset().top;
      const height = $('#js-header').outerHeight();
      $('.l-header').css( 'height', height);
      $(window).scroll(function () {
        // スクロール量がヘッダーの位置を超えた場合
        if ($(this).scrollTop() > pos) {
          // ヘッダーにfixedクラスを付与
          $('#js-header').addClass('fixed');
          // bodyにヘッダーの高さ分のpadding-topをつける
          //$( 'body' ).css( 'padding-top', height);
          // 超えない場合
          } else {
          //ヘッダーのfixedクラスを外す
          $('#js-header').removeClass('fixed');
          // bodyのpadding-topをなくす
          $( 'body' ).css( 'padding-top', 0);
        }
      });
    }
    headerFloatSwitch();
    jQuery(window).on('resize', function () {
      headerFloatSwitch();
    });

    // 1つの場合
    const matchHeight = document.querySelector('.matchHeight');
    if(matchHeight){
      $(function() {
        $('.matchHeight').matchHeight();
      });
    }

    const inputemail = document.querySelector('.l-footer_mainItem._02');
    if(inputemail){
      $(document).ready(function() {
        // input[type="email"] の値をクリアし、プレースホルダーを設定
        $('.l-footer_mainItem._02 input[type="email"]').val('').removeAttr('onfocus onblur').attr('placeholder', 'YOUR EMAIL HERE');
      });
    }
    


    //////mwwpform 同意ボタン checkbox制御
    // jQuery(function() {
    //   /* ページ読み込み時のボタン制御処理 */
    //   if ($('input[id="agreement_01"]:checked').val() && $('input[id="agreement_02"]:checked').val()) {
    //       $('[name="submitConfirm"]').prop("disabled", false);
    //   } else {
    //       $('[name="submitConfirm"]').prop("disabled", true);
    //   }

    //   /* 同意のチェックボックスをクリックした際のボタン制御処理 */
    //   $('[id="agreement_01"]').click(function() {
    //       if ($('input[id="agreement_01"]:checked').val() && $('input[id="agreement_02"]:checked').val()) {
    //           $('[name="submitConfirm"]').prop("disabled", false);
    //       } else {
    //           $('[name="submitConfirm"]').prop("disabled", true);
    //       }
    //   });
    //   $('[id="agreement_02"]').click(function() {
    //       if ($('input[id="agreement_02"]:checked').val() && $('input[id="agreement_02"]:checked').val()) {
    //           $('[name="submitConfirm"]').prop("disabled", false);
    //       } else {
    //           $('[name="submitConfirm"]').prop("disabled", true);
    //       }
    //   });
    // });
    
  });//jQuery

  
  if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
  }else{
    // マウスポインタ
    const stalker = document.getElementById('mouse-stalker');
    let hovFlag = false;

    document.addEventListener('mousemove', function (e) {
        stalker.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)';
    });

    const linkElem = document.querySelectorAll('a:not(.no_stick_)');
    for (let i = 0; i < linkElem.length; i++) {
        linkElem[i].addEventListener('mouseover', function (e) {
            hovFlag = true;
            stalker.classList.add('is_active');
        });
        linkElem[i].addEventListener('mouseout', function (e) {
            hovFlag = false;
            stalker.classList.remove('is_active');
        });
    }
  }

}
